module.exports = __webpack_public_path__ + "static/media/01-sillon-cut.b8c25914.jpg";